<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <div class="card mt-5">
          <div class="card-body login-card-body mt-3">
            <h3 class="login-box-msg" style="text-align: center">
              เข้าสู่ระบบ
            </h3>
            <form>
              <div class="card-body mt-3">
                <div class="form-group">
                  <label for="username">ชื่อผู้ใช้งาน</label>
                  <input v-model="user.username" v-on:keyup.enter="signIn()" type="text" min="1"
                    class="form-control form-control-md" id="username" />
                </div>
                <div class="form-group mt-3">
                  <label for="password">รหัสผ่าน</label>
                  <input v-model="user.password" v-on:keyup.enter="signIn()" type="password"
                    class="form-control form-control-md" id="password" />
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                  </div>

                  <div class="col-md-3"></div>
                  <div class="col-md-6 text-center">
                    <button @click="signIn()" type="button" class="btn btn-success btn-md">
                      เข้าสู่ระบบ
                    </button>
                  </div>
                  <div class="col-md-3"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/UserService.js";

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  data() {
    return {
      concert_id: 0,
      menu: [],
      user: {},
    };
  },
  mounted() {
console.log(this.currentUser,'login');

    UserService.getMenuByRole(this.currentUser.role).then((res) => {
      console.log(res.data);
      // if (res.data[0].url == '/activities_tracking') {
      //   this.$router.push(res.data[0].url+'/'+this.currentUser.id);
      // }else{
      //   this.$router.push(res.data[0].url)
      // }      
    });
  },
  methods: {
    texttobase(string) {
      // Encode the String
      var encodedString = btoa(string);
      return encodedString;
    },
    login() {
      var user = {
        username: this.user.username,
        password: this.user.password,
      };
      this.$store.dispatch("auth/login", user).then(
        () => {
          this.loading = true;
          console.log(this.currentUser,'login');
          UserService.getMenuByRole(this.currentUser.role_id).then((res) => {
            // console.log(res.data);
            // console.log(res.data[0].url+'/'+this.currentUser.user_id);
            
            this.$router.push(res.data[0].url+'/'+this.currentUser.user_id);
            // this.$router.push({
            //   name: res.data[0].url+,
            //   params: {
            //     id: this.currentUser.id,
            //   }
            // }).catch(err => {
            //   console.log(err);
            // });
            setTimeout(function () {
              location.reload();
            }, 100);
          });
        },
        (error) => {
          alert("ชื่อหรือรหัสผ่านไม่ถูกต้อง");
          console.log(error);
          // this.loading = false;
          // this.message =
          //   (error.response &&
          //     error.response.data &&
          //     error.response.data.message) ||
          //   error.message ||
          //   error.toString();
        }
      );
    },
    signIn() {
      if (this.user.username == "" || this.user.username == null) {
        alert("กรุณา username");
      } else if (this.user.password == "" || this.user.password == null) {
        alert("กรุณากรอกรหัสผ่าน");
      } else {
        this.login();
      }
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}

.card {
  margin: 0 auto;
  /* Added */
  float: none;
  /* Added */
  margin-bottom: 10px;
  /* Added */
}

body {
  background-color: gray;
}
</style>
